
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AddressDetails, { AddressHandler } from './address-details';
import { useMutation } from '@apollo/client';
import { useRef, useState } from 'react';
import { CREATE_ORG_ADDRESS, GET_ORG_ADDRESSES } from '../../../../graphql/contact-gql';
import { AddIcon, CancelIcon } from '../../../common/icons';
import { notifySuccess } from '../../../../services/notification';
import SpinnerOverlay from '../../../common/spinner/spinner';
import '../../org.scss';
import Button from '../../../common/button';

type AddressCreateProps = {
    orgId: number;
    isOpen: boolean;
    toggle: () => void;
}

const AddressCreate = (props: AddressCreateProps) => {
    const {orgId, isOpen, toggle} = props

    const [validated, setValidated] = useState<boolean>(false)
    const [typeaheadError, setTypeaheadError] = useState<string>("");
    const addressFormRef = useRef<AddressHandler>(null);
    const [createOrgAddress, {loading}] = useMutation(CREATE_ORG_ADDRESS);

    const onCreateAddress = () => {
        if (addressFormRef.current && !addressFormRef.current.validate(true)) {
            setValidated(false)
            return
        }

        let addressInput = addressFormRef.current && addressFormRef.current.getAddress();

        createOrgAddress({
            variables: {
                orgId: orgId,
                address: addressInput,
            },
            refetchQueries: [{
                query: GET_ORG_ADDRESSES,
                variables: { orgId: orgId } ,
            }],
            awaitRefetchQueries: true,
            onCompleted: (data) => {
                toggle()
                data && notifySuccess()
            }
        });
    }

    const onToggle = (event: any) => {
        if (event.target.nodeName !== 'SELECT') {
            toggle()
        }
    }

    const onChange = () => {
        setValidated(!!addressFormRef.current?.validate(false))
    }

    return (<>
        {loading && <SpinnerOverlay />}
        <Modal size="lg" isOpen={isOpen} toggle={onToggle} scrollable backdrop="static" autoFocus={false}>
            <ModalHeader toggle={toggle} tag={'h2'}>Add an Organization Address</ModalHeader>
            <ModalBody>
                <AddressDetails ref={addressFormRef} mandatory={true} onChange={onChange} onError={setTypeaheadError} autoFocus={true} />
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={onCreateAddress} disabled={!validated || !!typeaheadError}>
                    <AddIcon/> Add
                </Button>
                <Button color="secondary" onClick={toggle}>
                    <CancelIcon/> Cancel
                </Button>
            </ModalFooter>
        </Modal></>
    )
}

export default AddressCreate
